import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import {
  Course_created_successfully_image,
  Create_lesson_logo,
  delete_alert_popup,
  studentDashboard_AI_chatbot_image,
} from "../../../../../../assets/images/images";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import api from "../../../../../../api/api";
import Pagination from "@mui/material/Pagination";
import Grid from "@mui/material/Grid";
import dayjs from "dayjs";
import { truncate } from "../../../../../../utils/utlis";
import PaginationView from "../../../../../../components/PaginationView/PaginationView";
import { CircularProgress } from "@mui/material";
import {
  deleteLessonById,
  resetdeleteLesson,
} from "../../../../../../state/actions/deleteLessonAction";
import {
  deleteAssignmentById,
  resetdeleteAssignment,
} from "../../../../../../state/actions/deleteAssignmentAction";
import { toast } from "react-toastify";
import { alert_image,copyLessons_loaderGif } from "../../../../../../assets/images/images";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "react-tooltip";
import MenuItem from "@mui/material/MenuItem";
import StyledMenu from "../../../../../../components/StyleMenu";
import LessonCard from "./LessonCard";
import RemovePopup from "../../../../../../components/RemovePopup/RemovePopup";
import {
  removeStudentsFromCourse,
  resetremovestudents,
} from "../../../../../../state/actions/removeStudentsFromCourseAction";
import { getCourseTeachers } from "../../../../../../state/actions/getCourseTeachersAction";
import { getActivityLogs } from "../../../../../../state/actions/getActivityLogsAction";
import { addTeacher } from "../../../../../../state/actions/addTeacherAction";
import StudentsTable from "./StudentsTable";
import CopyLessonsModal from "../../../../../../components/CopyLessonsModal/CopyLessonsModal";
import { copyCourseContentApi } from "../../../../../../components/CopyLessonsModal/utils/apiHelper";
import Loader from "../../../../../../components/FileRepo/Components/Loader";
import "./CourseTab.css";


const CourseTab = ({
  course,
  teacher_id,
  refetchCourse,
  setTotalLessons,
  setTotalAssignments,
  setTotalStudent,
  addlessonBtn,
  activeTabCourse,
  setactiveTabCourse,
  dropDown,
  invitationSuccessfull,
  totalLessons,
  onCreateLesson,
  onNavigateNewLesson,
  lessonsRefreshKey = 0,
}) => {

  const [activeTab, setActiveTab] = useState("lessons");
  const [openModal,setOpenModal]=useState(false)
  const [isCopyingLessons, setIsCopyingLessons] = useState(false);

  const { token } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const globalState = useSelector((state) => state.globalState);

const handleCopyLessonsSubmit = async (payload) => {
  try {
    const finalPayload = {
      ...payload,
      target_course_ids: [course?.course_id],
    };

    await copyCourseContentApi({
      payload: finalPayload,
      token,
    });
    refreshLessonsList();
  setIsCopyingLessons(false);


    toast.success("Lessons copied successfully");
  } catch (error) {
    setIsCopyingLessons(false);
        const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Failed to Copy Selected Lessons";

    toast.error(errorMessage);
  }
};
  const handleTabClick = (tabName) => {
    if (token) {
      setActiveTab(tabName);
      setactiveTabCourse?.(tabName);
      if (tabName === "students") {
        studentdetailsget(`1,4,5`, true);
      }
      if (tabName === "studentsRequest") {
        studentdetailsget(3);
      }
      if (tabName === "manageTeachers" && course?.course_id) {
        dispatch(getCourseTeachers(course.course_id, token));
      }
      if (tabName === "activityLog" && course?.course_id) {
        setActivityLogPage(1);
        dispatch(getActivityLogs(course.course_id, token, 1));
      }
    }
  };
   
  const handleActivityLogPageChange = (event, value) => {
    if (!token || !course?.course_id) return;
    setActivityLogPage(value);
    dispatch(getActivityLogs(course.course_id, token, value));
    window.scrollTo(0, 0);
  };

  const [studentsRequest, setstudentsRequest] = useState([]);

  const getCourseTeachersState = useSelector(
    (state) => state.getCourseTeachers,
  );
  const manageTeachersList = getCourseTeachersState?.teachers ?? [];

  const getActivityLogsState = useSelector((state) => state.getActivityLogs);
  const activityLogsList = getActivityLogsState?.logs ?? [];
  const ACTIVITY_LOG_PAGE_SIZE = 12;
  const activityLogTotalPages =
    Math.ceil((getActivityLogsState?.count ?? 0) / ACTIVITY_LOG_PAGE_SIZE) || 1;
  const [activityLogPage, setActivityLogPage] = useState(1);

  const [studentcount, setstudentcount] = useState(0);
  const [lessonCount, setlessonCount] = useState(0);
  const [studentCurrentPage, setstudentCurrentPage] = useState(1);
  const [studentTotalPages, setstudentTotalPages] = useState(0);
  const [studentNext, setstudentNext] = useState(null);
  const [studentPrevious, setstudentPrevious] = useState(null);
  const [studentReqCurrentPage, setstudentReqCurrentPage] = useState(() => {
    const SavedPage = sessionStorage.getItem("page");
    return SavedPage ? parseInt(SavedPage) : 1;
  });
  const [studentReqTotalPages, setstudentReqTotalPages] = useState(0);
  const [studentReqNext, setstudentReqNext] = useState(null);
  const [studentReqPrevious, setstudentReqPrevious] = useState(null);
  const [students, setstudents] = useState([]);
  const [loadStudent, setloadStudent] = useState(false);
  const [lessondetails, setlessondetails] = useState(null);
  const [requestProcessMssg, setrequestProcessMssg] = useState(0);
  const [page, setPage] = useState(() => {
    const SavedPage = sessionStorage.getItem("page");
    return SavedPage ? parseInt(SavedPage) : 1;
  });
  const [totalPages, settotalPages] = useState(0);
  const [isLoding, setisLoding] = useState(false);
  const [lessonLoading, setLessonLoading] = useState(false);   // loader for lesson tab
  const [removeStudentsArray, setremoveStudentsArray] = useState([]);
  const [is_skip, setis_skip] = useState(null);
  const handlePageChange = (event, value) => {
    if (token) {
      setPage(value);
      let dynamic_url = ""; // setPage(value);
      if (value == 1) {
        dynamic_url = `lessons/get-all-lessons/course/${course?.course_id}/`;
        sessionStorage.removeItem("page");
      } else {
        dynamic_url = `lessons/get-all-lessons/course/${course?.course_id}/?page=${value}`;
        sessionStorage.setItem("page", value);
      }
      getLessondetails(dynamic_url);
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    if (course?.course_id && token) {
      dispatch(getCourseTeachers(course.course_id, token));
    }
  }, []);

  useEffect(() => {
    if (activeTabCourse.length && token) {
      setActiveTab(activeTabCourse);

    }
  }, [activeTabCourse]);

  useEffect(() => {
  if (isCopyingLessons) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return () => {
    document.body.style.overflow = "auto";
  };
}, [isCopyingLessons]);

  const studentdetailsget = (status, isStudentTab = false) => {
    setisLoding(true);
    api
      .get(
        `courses/teacher/enroll-course-requests/?course_id=${course?.course_id}&status=${status}&teacher_id=${teacher_id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        },
      )
      .then((response) => {
        if (response.data.status === 200) {
          setisLoding(false);
          if (status === 1) {
            setstudents(response.data.data);
          }
          if(isStudentTab){
            setstudents(response.data.data);
            setstudentcount(response?.data?.count);
          }
          if (status === 3) {
            setstudentsRequest(response.data.data);
            setstudentReqNext(response?.data?.next);
            setstudentReqPrevious(response?.data?.previous);
            setstudentReqTotalPages(
              Math.ceil((response?.data?.count ?? 0) / 12),
            );
          }
        }
      })
      .catch((error) => { });
  };

  const onPreviewLesson = (lesson) => {
    navigate("/NewLessons", { state: { course, teacher_id, lesson } });
  };

  const deleteLesson = useSelector((state) => state.deleteLesson);
  const deleteAssignment = useSelector((state) => state.deleteAssignment);
  const removestudentfromcourse = useSelector(
    (state) => state.removestudentfromcourse,
  );

  useEffect(() => {
    if (token) {
      const first_url = `lessons/get-all-lessons/course/${course?.course_id}/?page=${page}`;
      getLessondetails(first_url);
      api
        .get(
          `courses/teacher/enroll-course-requests/?course_id=${course?.course_id}&status=1,4,5&page=${studentCurrentPage}&teacher_id=${teacher_id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          },
        )
        .then((response) => {
          if (response.data.status == 200) {
            setstudents(response.data.data);
            setstudentcount(response?.data?.count);
            setTotalStudent(response?.data?.count);
            setstudentNext(response?.data?.next);
            setstudentPrevious(response?.data?.previous);
            setstudentTotalPages(Math.ceil((response?.data?.count ?? 0) / 12));
          }
        })
        .catch((error) => { });
      studentdetailsget(3);
    }
  }, [
    course?.course_id,
    studentCurrentPage,
    deleteLesson,
    deleteAssignment,
    removestudentfromcourse,
    invitationSuccessfull,
    loadStudent,
  ]);

  useEffect(() => {
    if (removestudentfromcourse?.message?.length) {
      toast.success(removestudentfromcourse.message);
      setremoveStudentsArray([]);
      setIsBulkDeleteMode(false);
      handleClose();
    } else if (removestudentfromcourse?.error?.length) {
      toast.error(removestudentfromcourse.error);
      handleClose();
    }

    return () => {
      dispatch(resetremovestudents());
    };
  }, [removestudentfromcourse]);

  let skip_lesson = false; //bb
 async function getLessondetails(url) {
  setLessonLoading(true);
   await api
      .get(url, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`, // `Token ${token}`
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setlessondetails(response.data.data);
          setlessonCount(response?.data?.count);
          setTotalLessons(response?.data?.count);
          setTotalAssignments(response?.data?.assignments_count);
          const totalItems = response?.data?.count;
          const totalPages_d = Math.ceil(totalItems / 12);
          settotalPages(totalPages_d);
        }
      })
      .catch((error) => {
        setTotalLessons(0);
        setlessondetails(null);
        setlessonCount(0);
      })
      .finally(() => {
        setLessonLoading(false);
      });
  }

  const refreshLessonsList = () => {
    if (!token || !course?.course_id) return;
    const url =
      page === 1
        ? `lessons/get-all-lessons/course/${course.course_id}/`
        : `lessons/get-all-lessons/course/${course.course_id}/?page=${page}`;
    getLessondetails(url);
  };

  useEffect(() => {
    if (!token || !course?.course_id || !lessonsRefreshKey) return;
    const first_url = `lessons/get-all-lessons/course/${course.course_id}/?page=${page}`;
    getLessondetails(first_url);
  }, [lessonsRefreshKey, course?.course_id, token]);

  const [showreuestsuccesfully, setshowreuestsuccesfully] = useState(false);

  const handleAcceptReject = (status, student_id) => {
    if (token) {
      setisLoding(true);
      setrequestProcessMssg(status);
      // Perform the API call using Axios
      const currentDate = new Date();

      // Convert to ISO string (YYYY-MM-DDTHH:MM:SS.sssZ) and slice to get YYYY-MM-DD format
      const formattedDate = currentDate.toISOString().slice(0, 10);

      const url = `courses/teacher/enroll-course-requests/?teacher_id=${teacher_id}`;
      const headers = {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      };
      api
        .post(
          url,
          {
            course_id: course.course_id,
            student_id: student_id,
            status: status,
            enrolled_on: formattedDate,
          },
          { headers },
        )
        .then((response) => {
          if (response.data.status === 200) {
            setloadStudent(true);
            setisLoding(false);
            const newStudentsRequest = studentsRequest.filter(
              (item) => item.student_id !== student_id,
            );
            setstudentsRequest(newStudentsRequest);
            setshowreuestsuccesfully(true);

            setOpenDialog(false);
            setTimeout(() => {
              setshowreuestsuccesfully(false);
            }, 1000);
          }
        })
        .catch((error) => { });
      setloadStudent(false);
    }
  };

  function formatDate(isoDate) {
    const date = new Date(isoDate);

    // Get individual date components
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // 'Jan', 'Feb', 'Mar' etc.
    const year = date.getFullYear();

    // Get the suffix for the day
    let suffix = "th";
    if (day % 10 === 1 && day !== 11) {
      suffix = "st";
    } else if (day % 10 === 2 && day !== 12) {
      suffix = "nd";
    } else if (day % 10 === 3 && day !== 13) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month}, ${year}`;
  }
  const onStudentViewProfile = (student) => {
    navigate(`/student/${student?.student_id}`, {
      state: { course, student },
    });
  };

  const AssignmentCard = ({ lesson, assignment }) => {
    const [deleteAssignment, setdeleteAssignment] = useState(false);

    const dispatch = useDispatch();
    const deleteAssignmentState = useSelector(
      (state) => state.deleteAssignment,
    );

    const deleteAssignmentReq = (id) => {
      dispatch(deleteAssignmentById(id, token));
    };
    return (
      <div className="preview-assignments-inner-folder">
        <ol>
          <li>{truncate(assignment.name, 15)}</li>
        </ol>
        <div className="Created-assignments-date">
          <p className="Created">Created:</p>
          <p>{dayjs(assignment.start_date).format("MMM DD, YYYY")}</p>
        </div>
        <div className="Created-assignments-date Created-assignments-due-date">
          <p className="due-date">Due date:</p>
          <p>{dayjs(assignment.end_date).format("MMM DD, YYYY")}</p>
        </div>
        <div
          className="View-Progress-btn"
          onClick={(e) => {
            e.preventDefault();
            const course_id = course?.course_id;
            const lesson_id = lesson?.lesson_id;
            const assignment_id = assignment?.assignment_id;
            navigate(
              `/course/${course_id}/lesson/${lesson_id}/assignment/${assignment_id}/progress`,
              { state: { course, teacher_id, lesson, assignment } },
            );
          }}
        >
          Assignment Progress
        </div>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            const course_id = course?.course_id;
            const lesson_id = lesson?.lesson_id;
            const assignment_id = assignment?.assignment_id;
            navigate(
              `/course/${course_id}/lesson/${lesson_id}/assignment/${assignment_id}/preview`,
              {
                state: {
                  course,
                  teacher_id,
                  lesson,
                  assignment,
                  isTeacher: true,
                },
              },
            );
          }}
        >
          Preview Assignment
        </button>
        <i
          class="fa-solid fa-trash"
          data-tooltip-id="delete-assignment"
          onClick={() => setdeleteAssignment(true)}
        ></i>
        <Tooltip
          id="delete-assignment"
          place="bottom"
          content="Delete Assignment"
          type="light"
          effect="float"
        />
        {deleteAssignment && (
          <form action="" className="delete-course-form">
            <div className="delete-course-form-container" data-aos="zoom-in">
              <div className="delete-course-alert-image">
                <img src={alert_image} alt="" />
              </div>
              <h2>Are you sure you want to delete this assignment?</h2>
              <div className="delete-course-form-btn-folder">
                <button
                  type="button"
                  onClick={() => setdeleteAssignment(false)}
                  className="not-delete-btn"
                >
                  No
                </button>
                {deleteAssignmentState?.isLoading ? (
                  <div className="loading-spinner" />
                ) : (
                  <button
                    type="button"
                    onClick={() =>
                      deleteAssignmentReq(assignment?.assignment_id)
                    }
                    disabled={deleteAssignmentState?.isLoading}
                    className="delete-btn"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          </form>
        )}
      </div>
    );
  };

  const [openDialog, setOpenDialog] = useState(false);
  const [getstudentid, setstudentid] = useState();
  const dropdownRef = useRef(null);

  const handleCancelClick = (student_Id) => {
    setOpenDialog(true);
    setstudentid(student_Id);
  };
  const cancelRegistration = () => {
    setOpenDialog(false);
    document.body.style.overflow = "auto";
  };

  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [isBulkDeleteMode, setIsBulkDeleteMode] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const activeTabLabel = 
  activeTab === "lessons" ? `Lessons (${lessonCount ?? 0})` :
  activeTab === "students" ? `Students (${studentcount ?? 0})` :
  activeTab === "studentsRequest" ? `Student Request (${studentsRequest?.length ?? 0})` :
  activeTab === "manageTeachers" ? `Manage Teachers (${manageTeachersList.length})` :
  activeTab === "activityLog" ? "Activity Log" : "";

  // Function to close the popup
  const handleClose = () => {
    setremoveStudentsArray([]);
    setIsDeletePopupOpen(false);
    setIsBulkDeleteMode(false);
  };

  // Function to handle the action after confirmation (optional extra functionality)
  const handleRemoveStudent = () => {
    // const studentArr = removeStudentsArray.map(Number);

    const req = {
      student_emails: removeStudentsArray,
      course_id: course?.course_id,
    };
    dispatch(removeStudentsFromCourse(req, token));
  };

  // Function to handle individual delete icon click
  const handleIndividualDelete = (email) => {
    if (email) {
      setremoveStudentsArray([email]);
      setIsBulkDeleteMode(false);
      setIsDeletePopupOpen(true);
    }
  }

  const handleDeleteCheck = (e) => {
    setIsBulkDeleteMode(true);
    if (removeStudentsArray.some(element => element === e.target.value)) {
      setremoveStudentsArray(removeStudentsArray.filter(element => element !== e.target.value))
    }
    else {
      setremoveStudentsArray([...removeStudentsArray, e.target.value]);
    }
  };

  const handleDeleteAll = (e) => {
    setIsBulkDeleteMode(true);
    if (e.target.checked) {
      setremoveStudentsArray(students.map((student) => student.student_email));
    } else {
      setremoveStudentsArray([]);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0); //bug fix 1614
  }, [studentCurrentPage, studentReqCurrentPage]);

  const assignmentRef = useRef(null);

  useEffect(() => {
    const handleFocus = () => {
      if (!document.hidden) {
        // ✅ Call your API or refresh data here
        if (token) {
          const first_url = `lessons/get-all-lessons/course/${course?.course_id}/?page=${page}`;
          getLessondetails(first_url);
        }
      }
    };

    document.addEventListener("visibilitychange", handleFocus);

    return () => {
      document.removeEventListener("visibilitychange", handleFocus);
    };
  }, [course]);

  useEffect(() => {
  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsDropdownOpen(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside)
  };
}, []);

  return (
    <>
      <div
        className="Create-Lesson-section"
        id="CreateLesson-section"
        ref={assignmentRef}
      >
        <div className="Create-Lesson-section-wrapper">
          <div className="view-lessons-section">
            <div className="view-lessons-wrapper">
              {
                <div className="view-lessons-btn-container teacehr-tab-setion teacher-course-tabs relative">
                  {/* Mobile Dropdown */}
                  <div className="mobile-tab-dropdown" ref={dropdownRef}>
                    <button
                      className="flex items-center gap-2 bg-transparent border-none border-b-[3px] border-b-[#0068ff] pb-2 text-[16px] font-semibold text-[#0068ff] cursor-pointer w-full"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                      <span>{activeTabLabel}</span>
                      <i
                        className={`fa-solid fa-chevron-${
                          isDropdownOpen ? "up" : "down"
                        } text-[14px] text-[#0068ff]`}
                      />
                    </button>

                    {isDropdownOpen && (
                      <div
                        className="absolute left-0 right-0 bg-white border border-[#e0e0e0] rounded-lg z-[100] py-2"
                        style={{ boxShadow: "0px 0px 8px 0px #0000001F" }}
                      >
                        <button
                          className={`w-full text-left py-2 text-[15px] border-none bg-transparent cursor-pointer ${
                            activeTab === "lessons"
                              ? "text-[#0068ff] font-semibold"
                              : "text-[#555]"
                          }`}
                          onClick={() => {
                            handleTabClick("lessons");
                            setIsDropdownOpen(false);
                          }}
                        >
                          Lessons {`(${lessonCount ?? 0})`}
                        </button>
                        <button
                          className={`w-full text-left py-2 text-[15px] border-none bg-transparent cursor-pointer ${
                            activeTab === "students"
                              ? "text-[#0068ff] font-semibold"
                              : "text-[#555]"
                          }`}
                          onClick={() => {
                            handleTabClick("students");
                            setIsDropdownOpen(false);
                          }}
                        >
                          Students {`(${studentcount ?? 0})`}
                        </button>
                        {course?.my_role !== "viewer" && (
                          <button
                            className={`w-full text-left py-2 text-[15px] border-none bg-transparent cursor-pointer ${
                              activeTab === "studentsRequest"
                                ? "text-[#0068ff] font-semibold"
                                : "text-[#555]"
                            }`}
                            onClick={() => {
                              handleTabClick("studentsRequest");
                              setIsDropdownOpen(false);
                            }}
                          >
                            Student Request{" "}
                            {`(${studentsRequest?.length ?? 0})`}
                          </button>
                        )}
                        <button
                          className={`w-full text-left py-2 text-[15px] border-none bg-transparent cursor-pointer ${
                            activeTab === "manageTeachers"
                              ? "text-[#0068ff] font-semibold"
                              : "text-[#555]"
                          }`}
                          onClick={() => {
                            handleTabClick("manageTeachers");
                            setIsDropdownOpen(false);
                          }}
                        >
                          Manage Teachers {`(${manageTeachersList.length})`}
                        </button>
                        <button
                          className={`w-full text-left py-2 text-[15px] border-none bg-transparent cursor-pointer ${
                            activeTab === "activityLog"
                              ? "text-[#0068ff] font-semibold"
                              : "text-[#555]"
                          }`}
                          onClick={() => {
                            handleTabClick("activityLog");
                            setIsDropdownOpen(false);
                          }}
                        >
                          Activity Log
                        </button>
                      </div>
                    )}
                  </div>
                  <button
                    className={` !px-3 tab-button desktop-only-tab ${
                      activeTab === "lessons" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("lessons")}
                  >
                    Lessons {`(${lessonCount ?? 0})`}
                  </button>
                  <button
                    className={` !px-3 tab-button desktop-only-tab ${
                      activeTab === "students" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("students")}
                  >
                    Students {`(${studentcount ?? 0})`}
                  </button>
                  {course?.my_role !== "viewer" && (
                    <button
                      className={`!px-3 tab-button desktop-only-tab ${
                        activeTab === "studentsRequest" ? "active" : ""
                      }`}
                      onClick={() => handleTabClick("studentsRequest")}
                    >
                      Student Request {`(${studentsRequest?.length ?? 0})`}
                    </button>
                  )}
                  <button
                    className={` !px-3 tab-button desktop-only-tab  ${
                      activeTab === "manageTeachers" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("manageTeachers")}
                  >
                    Manage Teachers {`(${manageTeachersList.length})`}
                  </button>
                  <button
                    className={` !px-3 tab-button desktop-only-tab  ${
                      activeTab === "activityLog" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("activityLog")}
                  >
                    Activity Log
                  </button>

                 { !course.is_archived && (<div className="lesson-action-buttons">
                    
                    {totalLessons > 0 &&
                      activeTab === "lessons" &&
                      course?.my_role !== "viewer" &&
                      globalState.enabled_modules?.includes("copy_lessons") && (
                        <div className="copy-lesson-btn">
                          <button
                          className="assignments_count_details text-xs sm:text-base"
                            id="copy-lesson-button"
                            data-tooltip-id="user_role"
                            type="button"
                            onClick={() => setOpenModal(true)}
                          >
                            Copy Lesson
                          </button>
                        </div>
                      )}
                      {addlessonBtn}
                  </div>)}
                </div>
              }
              <div className="tab-content">
                {lessonLoading && activeTab === "lessons" ? (
                  <Loader />
                ): <>
                {totalLessons === 0 && activeTab === "lessons" ? (
                  <div className="view-course-details-Create-lesson-container">
                    <div className="view-course-details-Create-lesson-container-image">
                      <img src={Create_lesson_logo} alt="" />
                    </div>

                    {/* // course?.my_role !== "viewer" && (<> */}
                    <p>Lets create your first lesson</p>
                    <div className="flex gap-2 justify-center flex-col md:flex-row">
                      {((course?.my_role !== "viewer" && !course?.is_archived)) && 
                        globalState.enabled_modules?.includes(
                          "copy_lessons",
                        ) && (
                          <button
                            style={{
                              display: globalState.enabled_modules?.includes(
                                "copy_lessons",
                              )
                                ? "block"
                                : "none",
                            }}
                            id="copy-lesson-button"
                            data-tooltip-id="user_role"
                            type="button"
                            onClick={() => setOpenModal(true)}
                          >
                            Copy Lesson
                          </button>
                        )}
                         <button
                        data-tooltip-id="user_role"
                        disabled={course?.my_role === "viewer"}
                        type="button"
                        onClick={onCreateLesson}
                      >
                        Create Lesson
                      </button>
                    </div>
                    {course?.my_role === "viewer" && (
                      <Tooltip
                        id="user_role"
                        place="bottom"
                        content="You are not able to create the lesson because you are a viewer in this lesson."
                        type="light"
                        effect="float"
                      />
                    )}
                  </div>
                ) : (
                  <>
                    {lessondetails &&
                      lessondetails.length > 0 &&
                      activeTab === "lessons" &&
                      (lessondetails && Array.isArray(lessondetails)
                        ? lessondetails.map((value, index) => (
                            <LessonCard
                              key={value?.lesson_id ?? index}
                              lesson={value}
                              course={course}
                              teacher_id={teacher_id}
                              accessControl={false}
                              userRoleCourseRights={false}
                              onNavigateNewLesson={onNavigateNewLesson}
                              onLessonsListRefresh={refreshLessonsList}
                            />
                          ))
                        : null)}
                  </>
                )}
                {lessondetails &&
                  lessondetails.length > 0 &&
                  activeTab === "lessons" && totalPages > 1 && (
                    <Grid container justifyContent="center" alignItems="center">
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                      />
                    </Grid>
                  )} </>}

                {activeTab === "students" && (
                  <StudentsTable
                    columns={[
                      {
                        header: "Student Name",
                        key: "student_name",
                        type: "profile",
                      },
                      {
                        header:"Status",
                        key:"student_status",
                        type:"status",
                      },
                      { header: "Student Id", key: "student_id" },
                      { header: "Grade", key: "student_grade" },
                      { header: "Email Id", key: "student_email" },
                      {
                        header: "Enrolled On",
                        key: "enrolled_on",
                        type: "date",
                      },
                    ]}
                    data={students}
                    isLoading={isLoding}
                    emptyMessage="No students records found."
                    wrapperId="list-of-students"
                    leadingColumn="checkbox"
                    trailingColumn="viewProfile"
                    showSearch
                    searchPlaceholder="Search Students or Email Id"
                    formatDate={formatDate}
                    defaultAvatar={studentDashboard_AI_chatbot_image}
                    onStudentViewProfile={onStudentViewProfile}
                    removeStudentsArray={removeStudentsArray}
                    onDeleteCheck={handleDeleteCheck}
                    onDeleteAll={handleDeleteAll}
                    onOpenRemovePopup={() => {
                      setIsBulkDeleteMode(true);
                      setIsDeletePopupOpen(true);
                    }}
                    onIndividualDelete={handleIndividualDelete}
                    isBulkDeleteMode={isBulkDeleteMode}
                    isDeletePopupOpen={isDeletePopupOpen}
                    dataLengthForSelectAll={students?.length}
                    totalPages={studentTotalPages}
                    next={studentNext}
                    previous={studentPrevious}
                    currentPage={studentCurrentPage}
                    setCurrentPage={setstudentCurrentPage}
                    activeTab={activeTab}
                    myRole={course?.my_role}
                    overlay={
                      isDeletePopupOpen && (
                        <RemovePopup
                          title="Are you sure you want to remove this student?"
                          cancel="No"
                          submit="Remove"
                          onclick={handleRemoveStudent}
                          onClose={handleClose}
                          image={delete_alert_popup}
                        />
                      )
                    }
                     statusConfig={{
    "Purchased": { backgroundColor: "#ECCCFF", color: "#000000" },  // peach/orange
    "Enrolled":  { backgroundColor: "#EBF3FF", color: "#0068FF" },  // mint green
  }}
                  />
                )}
                {activeTab === "manageTeachers" && (
                  <StudentsTable
                    columns={[
                      {
                        header: "Teacher Name",
                        key: "name",
                        type: "profile",
                        imageKey: "teacher_profile_pic",
                        nameKey: "name",
                      },
                      { header: "Email Id", key: "email" },
                      {
                        header: "Access",
                        key: "teacher_collaborator_roles.code",
                        type: "accessRole",
                      },
                    ]}
                    data={manageTeachersList}
                    isLoading={getCourseTeachersState?.isLoading}
                    defaultAvatar={studentDashboard_AI_chatbot_image}
                    emptyMessage="No teachers found."
                    wrapperClassName="manage-teachers-wrapper"
                    activeTab={activeTab}
                    getRowKey={(row) =>
                      row?.id ?? row?.teacher_id ?? row?.email
                    }
                    searchByNameKey="name"
                    myRole={course?.my_role}
                    onAccessRoleChange={(row, newRole) => {
                      if (!course?.course_id || !token || !row?.id) return;
                      dispatch(
                        addTeacher(
                          course.course_id,
                          { id: row.id, role: newRole },
                          token,
                          true,
                        ),
                      );
                    }}
                    onTransferComplete={refetchCourse}
                  />
                )}
                {activeTab === "activityLog" && (
                  <>
                    <StudentsTable
                      columns={[
                        { header: "Date", key: "date" },
                        {
                          header: "Teacher Name",
                          key: "teacher_name",
                          type: "profile",
                          imageKey: "ai_avatar",
                          nameKey: "teacher_name",
                        },
                        { header: "Action", key: "action" },
                        { header: "Details", key: "details" },
                      ]}
                      data={activityLogsList}
                      isLoading={getActivityLogsState?.isLoading}
                      activeTab={activeTab}
                      emptyMessage="No activity log found."
                      wrapperClassName="activity-log-wrapper"
                      defaultAvatar={studentDashboard_AI_chatbot_image}
                      getRowKey={(row, index) =>
                        row?.id ?? `${row?.teacher_id}-${row?.date}-${index}`
                      }
                      courseId={course?.course_id}
                    />
                    {activityLogTotalPages > 1 && (
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{ mt: 2 }}
                      >
                        <Pagination
                          count={activityLogTotalPages}
                          page={activityLogPage}
                          onChange={handleActivityLogPageChange}
                        />
                      </Grid>
                    )}
                  </>
                )}
                {activeTab === "studentsRequest" && (
                  <StudentsTable
                    columns={[
                      {
                        header: "Student Name",
                        key: "student_name",
                        type: "profile",
                      },
                      { header: "Student Id", key: "student_id" },
                      { header: "Grade", key: "student_grade" },
                      {
                        header: "Requested On",
                        key: "enrolled_on",
                        type: "date",
                      },
                      ...(course?.my_role !== "viewer"
                        ? [
                            {
                              header: "Request",
                              key: "student_id",
                              type: "acceptReject",
                            },
                          ]
                        : []),
                    ]}
                    data={studentsRequest}
                    isLoading={isLoding}
                    activeTab={activeTab}
                    emptyMessage="No students request found."
                    wrapperClassName="student-request-wrapper"
                    formatDate={formatDate}
                    defaultAvatar={studentDashboard_AI_chatbot_image}
                    onStudentViewProfile={onStudentViewProfile}
                    onReject={handleCancelClick}
                    onAccept={handleAcceptReject}
                    totalPages={studentReqTotalPages}
                    next={studentReqNext}
                    previous={studentReqPrevious}
                    myRole={course?.my_role}
                    currentPage={studentReqCurrentPage}
                    setCurrentPage={setstudentReqCurrentPage}
                    overlay={
                      openDialog && (
                        <div className="Course-created-successfully-main">
                          <div className="Course-created-successfully-container">
                            <div className="Course-created-successfully-folder">
                              <h2>
                                Are you sure you want to reject the request?
                              </h2>
                              <div className="Course-close-btn">
                                <button
                                  type="button"
                                  onClick={cancelRegistration}
                                >
                                  No
                                </button>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleAcceptReject(2, getstudentid)
                                  }
                                  className="Course-close"
                                >
                                  Yes
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {openModal && (
          <CopyLessonsModal
            course={course}
            open={openModal}
            onClose={() => setOpenModal(false)}
            mode="copy"
            onSubmit={handleCopyLessonsSubmit}
            teacherId={teacher_id}
            setIsCopyingLessons={setIsCopyingLessons}
          />
        )}
        {showreuestsuccesfully && (
          <div className="Course-created-successfully-main">
            <div className="Course-created-successfully-container">
              <div className="Course-created-successfully-folder">
                <div className="Course-created-successfully-image">
                  <img src={Course_created_successfully_image} alt="" />
                </div>
                <h2>
                  {requestProcessMssg === 4
                    ? "Request Accepted."
                    : requestProcessMssg === 2
                    ? "Request Rejected."
                    : ""}
                </h2>
              </div>
            </div>
          </div>
        )}
        {isCopyingLessons && (
          <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-white/70 backdrop-blur-sm">
            <div className="relative flex flex-col items-center gap-5">
              <div className="w-[70px] h-[70px] flex items-center justify-center">
                <img
                  src={copyLessons_loaderGif}
                  alt="transferring"
                  className="w-full h-full object-contain"
                />
              </div>

              <p className="text-[18px] font-semibold text-[#2B2B2B] text-center">
                Transferring selected lessons to your course.
                <span className="font-normal"> This may take a moment...</span>
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CourseTab;